import Vue from 'vue'
import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_ENV_API_ROUTE

Vue.use({
    install(Vue){
        Vue.prototype.$http = axios.create({
            baseURL: process.env.VUE_APP_ENV_API_ROUTE
        })
    }
})